import type { Article } from "./types";

export const physicalAndDigitalInvitations: Article = {
  slug: "physical-and-digital-invitations",
  published: true,
  publishedAt: "2026-10-27",
  updatedAt: "2026-10-27",
  title: {
    ro: "Invitații fizice și digitale: cum le combini inteligent",
    en: "Physical and digital invitations: how to combine them seamlessly",
  },
  summary: {
    ro: "Cum păstrezi farmecul invitațiilor tipărite pentru familie, dar centralizezi toate confirmările RSVP, meniurile și darurile online.",
    en: "How to keep the charm of printed invitations for close family while centralizing all RSVPs, meal preferences and online gifts.",
  },
  body: {
    ro: [
      { t: "h2", text: "De ce tot mai multe cupluri aleg varianta hibridă" },
      {
        t: "p",
        text: "Invitațiile tipărite pe hârtie rămân o amintire frumoasă pentru părinți, nași și bunici, însă colectarea confirmărilor prin telefon devine rapid dificilă când ai peste 100 de invitați.",
      },
      { t: "h2", text: "Cum centralizezi toți invitații într-o singură listă" },
      {
        t: "p",
        text: "Pe Jubiel poți combina ambele metode fără să pierzi evidența familiilor sau a locurilor la mese.",
      },
      {
        t: "ul",
        items: [
          "Tipărește link-ul scurt al evenimentului pe invitațiile fizice.",
          "Adaugă manual în tab-ul „Invitați” rudele care îți confirmă telefonic.",
          "Alocă fiecare familie la masă și exportă opisul complet în format CSV pentru sală.",
        ],
      },
    ],
    en: [
      { t: "h2", text: "Why more couples choose a hybrid approach" },
      {
        t: "p",
        text: "Printed paper invitations remain a cherished keepsake for parents, godparents and grandparents, but collecting RSVPs by phone quickly becomes difficult when you have over 100 guests.",
      },
      { t: "h2", text: "How to keep every guest in one unified list" },
      {
        t: "p",
        text: "On Jubiel you can combine both methods without losing track of households or table seating.",
      },
      {
        t: "ul",
        items: [
          "Print your event's short link on the physical invitations.",
          "Manually add relatives who confirm by phone in the “Guests” tab.",
          "Assign each household to a table and export the complete seating sheet as CSV for the venue.",
        ],
      },
    ],
  },
};
